import { useCallback, useMemo, useState } from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { appointmentConst, UrlPaths } from '../../../../../constants';

export const useAppointmentModals = ({
  navigate,
  customerId,
  form,
  setCustomerConfirmedEdit,
  setIsNotesModalOpen,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmType, setConfirmType] = useState(null);

  const closeModal = () => setIsModalOpen(false);
  const openModal = (type) => {
    setConfirmType(type);
    setIsModalOpen(true);
  };

  const confirmBody = useMemo(
    () => ({
      missedAppointments: {
        title: appointmentConst.MISSED_APPOINTMENTS_ALERT.TITLE,
        icon: <ExclamationCircleOutlined />,
        content: appointmentConst.MISSED_APPOINTMENTS_ALERT.DESCRIPTION,
        okText: appointmentConst.MISSED_APPOINTMENTS_ALERT.OK_BUTTON,
        cancelButtonProps: { style: { display: 'none' } },
      },

      blackList: {
        title: appointmentConst.BLACKLIST_ALERT.TITLE,
        icon: <ExclamationCircleOutlined />,
        content: appointmentConst.BLACKLIST_ALERT.DESCRIPTION,
        okText: appointmentConst.BLACKLIST_ALERT.OK_BUTTON,
        cancelText: appointmentConst.BLACKLIST_ALERT.CANCEL_BUTTON,
        onOk: () => navigate(`${UrlPaths.CUSTOMERS}/${customerId}`),
        onCancel: () => navigate(UrlPaths.AGENDA),
      },

      notes: {
        title: appointmentConst.NOTES_ALERT.TITLE,
        icon: <ExclamationCircleOutlined />,
        content: appointmentConst.NOTES_ALERT.DESCRIPTION,
        okText: appointmentConst.NOTES_ALERT.OK_BUTTON,
        cancelText: appointmentConst.NOTES_ALERT.CANCEL_BUTTON,
        onOk: () => {
          setIsNotesModalOpen(true);
          closeModal();
        },
        onCancel: closeModal,
      },

      isAdult: {
        title: appointmentConst.ADULT_ALERT.TITLE,
        icon: <ExclamationCircleOutlined />,
        content: appointmentConst.ADULT_ALERT.DESCRIPTION,
        okText: appointmentConst.ADULT_ALERT.OK_BUTTON,
        cancelText: appointmentConst.ADULT_ALERT.CANCEL_BUTTON,
        onOk: () => navigate(`${UrlPaths.CUSTOMERS}/${customerId}`),
      },

      editWithin24h: {
        title: appointmentConst.EDIT_WITHIN_24H_ALERT.TITLE,
        icon: <ExclamationCircleOutlined />,
        content: appointmentConst.EDIT_WITHIN_24H_ALERT.DESCRIPTION,
        okText: appointmentConst.EDIT_WITHIN_24H_ALERT.OK_BUTTON,
        cancelText: appointmentConst.EDIT_WITHIN_24H_ALERT.CANCEL_BUTTON,
        onOk: () => {
          setCustomerConfirmedEdit(true);
          closeModal();
          form.submit();
        },
        onCancel: () => {
          setCustomerConfirmedEdit(false);
          closeModal();
          form.submit();
        },
      },
    }),
    [navigate, customerId, form, setCustomerConfirmedEdit, setIsNotesModalOpen]
  );

  const showConfirm = useCallback(() => {
    if (confirmType) {
      Modal.confirm(confirmBody[confirmType]);
    }
  }, [confirmType, confirmBody]);

  return {
    openModal,
    closeModal,
    showConfirm,
    confirmType,
    isModalOpen,
  };
};
